import { PortfolioPreferences, PreferenceUpgrader } from '../../types';

const portfolioPreferencesMigration: PreferenceUpgrader<PortfolioPreferences> = {
  latestVersion: 1,
  steps: {
    // v0 -> v1: introduce `defaultView` with a 'compact' default when it has not been set.
    0: (old) => ({ ...old, defaultView: old.defaultView ?? 'compact', version: 1 }),
  },
};

export default portfolioPreferencesMigration;
